import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// File copied from packages/editor/editor-markdown-transformer/src/media.ts

function createRule() {
  // Ignored via go/ees005
  // eslint-disable-next-line require-unicode-regexp
  var regx = /!\[[^\]]*\]\([^)]+\)/g;
  // Allow paragraph_close as a valid parent token for cases where a user has an image at the end of a paragraph
  // due to shift+enter
  var validParentTokens = ['th_open', 'td_open', 'list_item_open', 'paragraph_close'];

  /**
   * This function looks for strings that matches ![description](url) inside Inline-tokens.
   * It will then split the Inline-token with content before and after the image, example:
   *
   * Input (tokens):
   *   paragraph_open
   *   inline - content: Hello ![](image.jpg) World!
   *   paragraph_close
   * Output (tokens):
   *   paragraph_open
   *   inline - content: Hello
   *   paragraph_close
   *   media_single_open
   *   media
   *   media_single_close
   *   paragraph_open
   *   inline - content: World!
   *   paragraph_close
   *
   * This is applied before the inline content is parsed, to ensure that the formatting of
   * remaining inline content (bold, links, etc.) is kept intact!
   */
  return function media(State) {
    var getUrl = function getUrl(str) {
      var res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
      if (res.ok) {
        var href = State.md.normalizeLink(res.str);
        if (State.md.validateLink(href)) {
          return href;
        }
      }
      return '';
    };
    var createMediaTokens = function createMediaTokens(url) {
      var mediaSingleOpen = new State.Token('media_single_open', '', 1);
      var media = new State.Token('media', '', 0);
      media.attrs = [['url', getUrl(url)], ['type', 'external']];
      if (url.includes('atlassianinternalmedia')) {
        try {
          var urlObject = new URL(getUrl(url));
          var params = urlObject.searchParams;
          if (params.toString()) {
            var pmAttrs = {};
            var _iterator = _createForOfIteratorHelper(params),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _step$value = _slicedToArray(_step.value, 2),
                  key = _step$value[0],
                  value = _step$value[1];
                pmAttrs[key] = value;
              }

              // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            media.pmAttrs = pmAttrs;
          }
        } catch (_unused) {}
      }
      var mediaSingleClose = new State.Token('media_single_close', '', -1);
      return [mediaSingleOpen, media, mediaSingleClose];
    };
    var createInlineTokens = function createInlineTokens(str, openingTokens, closingTokens) {
      if (!str || str.length === 0) {
        return [];
      }
      var inlineBefore = new State.Token('inline', '', 1);
      inlineBefore.content = str;
      inlineBefore.children = [];
      return [].concat(_toConsumableArray(openingTokens), [inlineBefore], _toConsumableArray(closingTokens));
    };
    var processedTokens = [];
    var newTokens = State.tokens.reduce(function (tokens, token, i, arr) {
      if (token.type === 'inline' && regx.test(token.content)) {
        var openingTokens = [];
        var cursor = i - 1;
        var previousToken = arr[cursor];
        var subTree = [];
        while (previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1) {
          openingTokens.unshift(previousToken);
          cursor--;
          previousToken = arr[cursor];
        }
        if (validParentTokens.indexOf(previousToken.type) === -1) {
          openingTokens.unshift(previousToken);
        } else {
          cursor++;
        }
        var closingTokens = openingTokens.map(function (token) {
          return new State.Token(token.type.replace('_open', '_close'), token.tag, -1);
        }).reverse();

        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var matches = token.content.match(regx);
        var inlineContentStack = token.content;
        matches.forEach(function (match) {
          var start = inlineContentStack.indexOf(match);
          var contentBefore = inlineContentStack.substr(0, start);
          inlineContentStack = inlineContentStack.substr(start + match.length);
          subTree = [].concat(_toConsumableArray(subTree), _toConsumableArray(createInlineTokens(contentBefore, openingTokens, closingTokens)), _toConsumableArray(createMediaTokens(match)));
        });
        if (inlineContentStack.length) {
          subTree = [].concat(_toConsumableArray(subTree), _toConsumableArray(createInlineTokens(inlineContentStack, openingTokens, closingTokens)));
        }
        processedTokens = [].concat(_toConsumableArray(processedTokens), _toConsumableArray(closingTokens.map(function (c) {
          return c.type;
        })));
        tokens = [].concat(_toConsumableArray(tokens.slice(0, cursor)), _toConsumableArray(subTree));
      } else if (processedTokens.indexOf(token.type) !== -1) {
        // Ignore token if it's already processed
        processedTokens.splice(processedTokens.indexOf(token.type), 1);
      } else {
        tokens.push(token);
      }
      return tokens;
    }, []);
    State.tokens = newTokens;
    return true;
  };
}

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var markdownItMedia = function markdownItMedia(md) {
  md.core.ruler.before('inline', 'media', createRule());
};